"use strict";

var _interopRequireDefault = require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.regexp.match");

var _index = require("@/api/index");

var _util = require("@/utils/util");

var _wx = require("@/utils/wx");

var _openApp = _interopRequireDefault(require("@/components/open-app"));

var _initJsBridge = _interopRequireDefault(require("@/utils/initJsBridge"));

var _dsbridge = _interopRequireDefault(require("dsbridge"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var u = navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端

var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

var _default = {
  name: 'Live',
  components: {
    OpenApp: _openApp.default
  },
  filters: {
    formatDate: function formatDate(date) {
      return (0, _util.formatDate)(date);
    },
    convertStockMarket: function convertStockMarket(market) {
      return (0, _util.convertStockMarket)(market);
    }
  },
  data: function data() {
    return {
      isSkeleton: true,
      aliplayerLoaded: false,
      mediaId: '',
      isLive: '',
      aliSTSAccessInfo: {},
      recommendVideos: [],
      videoDetail: '',
      isIphoneX: (0, _util.getIsIphonex)(),
      isApp: (0, _util.getIsAppClient)(),
      isAndroidOrIos: true
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    document.title = '汇金智通-视频';
    next(function (vm) {
      vm.importAliPlayer();

      if (window.Aliplayer) {
        vm.aliplayerLoaded = true;
      }

      window.addEventListener('load', function () {
        vm.aliplayerLoaded = true;
      });
    });
  },
  computed: {
    bottomPadding: function bottomPadding() {
      var className = '';

      if (!this.isApp && this.isAndroidOrIos && this.isIphoneX) {
        className = 'pb-77';
      } else if (!this.isApp && this.isAndroidOrIos && !this.isSkeleton) {
        className = 'pb-65';
      }

      return className;
    },
    createAliPlayer: function createAliPlayer() {
      if (!this.isSkeleton && this.aliplayerLoaded) {
        return true;
      }

      return false;
    },
    relatedCompany: function relatedCompany() {
      if (!this.videoDetail.companyName) {
        return '--';
      } else if (!this.videoDetail.companyCode) {
        return "".concat(this.videoDetail.companyName);
      }

      return "".concat(this.videoDetail.companyName, " \uFF08").concat(this.videoDetail.companyCode, "\uFF09");
    },
    mobileLiveVideo: function mobileLiveVideo() {
      if (this.isAndroidOrIos && this.videoDetail.isLive === 1 && this.videoDetail.status === 1) {
        return true;
      }

      return false;
    }
  },
  watch: {
    createAliPlayer: function createAliPlayer(newValue) {
      if (newValue) {
        this.aliplayerConfigurate(this.aliSTSAccessInfo, this.videoDetail);
      }
    }
  },
  created: function created() {
    if (!isAndroid && !isiOS) {
      this.isAndroidOrIos = false;
    }

    this.mediaId = this.$route.query.mediaId;
    this.isLive = this.$route.query.isLive;
    this.fetchVideoDetail();
    this.recordUserVisitedCount();
  },
  methods: {
    importAliPlayer: function importAliPlayer() {
      var _this = this;

      var script = document.createElement('script'); // script.setAttribute('src', 'https://g.alicdn.com/de/prismplayer/2.9.3/aliplayer-min.js')

      script.setAttribute('src', 'https://g.alicdn.com/de/prismplayer/2.9.3/aliplayer-h5-min.js');
      script.setAttribute('defer', 'defer');
      var cssStyleSheet = document.createElement('link');
      cssStyleSheet.setAttribute('rel', 'stylesheet');
      cssStyleSheet.setAttribute('href', 'https://g.alicdn.com/de/prismplayer/2.9.3/skins/default/aliplayer-min.css');
      document.head.appendChild(cssStyleSheet);
      document.head.appendChild(script);
      window.addEventListener('load', function () {
        _this.aliplayerLoaded = true;
      });
    },
    fetchVideoDetail: function fetchVideoDetail() {
      var _this2 = this;

      var apiList = [(0, _index.getVideoDetail)(this.mediaId), (0, _index.getRecommendVideoInfo)(this.mediaId), (0, _index.getSTSAccess)()];
      var promiseList = Promise.all(apiList);
      promiseList.then(function (response) {
        _this2.videoDetail = response[0].body;
        _this2.recommendVideos = response[1].body;
        _this2.aliSTSAccessInfo = response[2].body;
        _this2.isSkeleton = false;
        (0, _wx.shareConfig)(_this2.videoDetail.title, _this2.videoDetail.title, _this2.videoDetail.imageUrl);
      }).catch(function (error) {
        console.error(error);
      });
    },
    aliplayerConfigurate: function aliplayerConfigurate(_ref, _ref2) {
      var accessKeyId = _ref.accessKeyId,
          securityToken = _ref.securityToken,
          accessKeySecret = _ref.accessKeySecret,
          regionId = _ref.regionId;
      var imageUrl = _ref2.imageUrl,
          mediaUrl = _ref2.mediaUrl,
          mediaAliyunId = _ref2.mediaAliyunId,
          isLive = _ref2.isLive,
          status = _ref2.status,
          mediaType = _ref2.mediaType;
      mediaType = mediaType === 'mp3' ? 'audio' : 'video';
      new window.Aliplayer({
        id: 'player',
        width: '100%',
        height: '100%',
        autoplay: false,
        source: status === 1 && isLive === 1 ? mediaUrl : '',
        vid: mediaAliyunId,
        useH5Prism: true,
        controlBarVisibility: 'click',
        mediaType: mediaType,
        isLive: isLive === 1 && status === 1,
        // 是否是直播
        encryptType: 1,
        cover: imageUrl,
        accessKeyId: accessKeyId,
        securityToken: securityToken,
        accessKeySecret: accessKeySecret,
        region: regionId || 'cn-shenzhen'
      }, function () {});
    },
    backgroundImageUrl: function backgroundImageUrl(_ref3) {
      var isLive = _ref3.isLive,
          status = _ref3.status,
          mediaAliyunId = _ref3.mediaAliyunId;
      var videoType = '';
      var backgroundUrl = '';

      if (isLive === 1 && status === 1) {
        videoType = 'live';
      } else if (mediaAliyunId) {
        videoType = 'replay';
      } else if (status === 0) {
        videoType = 'order';
      }

      switch (videoType) {
        case 'live':
          backgroundUrl = "background-image: url(".concat(require('@/assets/images/live.png'), ")");
          break;

        case 'replay':
          backgroundUrl = "background-image: url(".concat(require('@/assets/images/replay.png'), ")");
          break;

        case 'order':
          backgroundUrl = "background-image: url(".concat(require('@/assets/images/order.png'), ")");
          break;

        default:
          break;
      }

      return backgroundUrl;
    },
    openApp: function openApp(mediaId, isLive) {
      if (!this.isApp && this.isAndroidOrIos) {
        var query = {};

        if (mediaId && isLive) {
          query.mediaId = mediaId;
          query.isLive = isLive;
        }

        this.$router.push({
          name: 'OpenInBrowser',
          query: query
        });
      } else if (this.isApp) {
        this.nativeOpenVideo(mediaId, isLive);
      }
    },
    nativeOpenVideo: function nativeOpenVideo(mediaId, isLive) {
      if ((0, _util.getIsAppClient)()) {
        if (isiOS) {
          var query = {
            mediaId: String(mediaId),
            isLive: Number(isLive)
          };
          (0, _initJsBridge.default)(function () {
            window.WKWebViewJavascriptBridge.callHandler('openVideo', query, function () {});
          });
        } else {
          this.$router.push({
            name: 'Live',
            query: {
              mediaId: mediaId,
              isLive: isLive
            }
          });
        }
      }
    },
    recordUserVisitedCount: function recordUserVisitedCount() {
      // 记录用户阅读资讯的数量
      if (this.isApp) {
        if (isAndroid) {
          _dsbridge.default.call('nativeReadData', {
            name: 'token'
          }, function (token) {
            console.log('token', token);

            if (token !== '-1') {
              (0, _index.recordUserVisitedCount)(token, 'R3') // R3代表阅读资讯
              .then(function () {}).catch(function () {});
            }
          });
        } else if (isiOS) {
          (0, _initJsBridge.default)(function () {
            window.WKWebViewJavascriptBridge.callHandler('nativeReadData', {
              name: 'token'
            }, function (token) {
              console.log('token', token);

              if (token !== '-1') {
                (0, _index.recordUserVisitedCount)(token, 'R3') // R3代表阅读资讯
                .then(function () {}).catch(function () {});
              }
            });
          });
        }
      }
    }
  }
};
exports.default = _default;